import { z } from 'zod'

export const ROBOT_TYPE_FORMATS = ['POUCHES', 'BLISTER'] as const
export const ROBOT_TYPE_MODES = ['SEMI', 'AUTO', 'MANUAL'] as const
export const ROBOT_TYPE_STATUSES = ['ACTIVE', 'INACTIVE'] as const

const requiredField = { message: 'common:requiredField' }
const requiredEnum = { errorMap: () => requiredField }

const patientsField = z
  .number({ invalid_type_error: requiredField.message, required_error: requiredField.message })
  .int({ message: 'robotTypes:validation.integer' })
  .min(0, { message: 'robotTypes:validation.nonNegative' })

export const RobotTypeSchema = z.object({
  robotTypeId: z.string().nullable(),
  model: z.string(),
  minPatients: z.number(),
  maxPatients: z.number(),
  format: z.enum(ROBOT_TYPE_FORMATS),
  mode: z.enum(ROBOT_TYPE_MODES),
  status: z.enum(ROBOT_TYPE_STATUSES),
})

export const RobotTypesSchema = z.array(RobotTypeSchema)

export const SaveRobotTypeSchema = z
  .object({
    model: z.string().trim().min(1, requiredField),
    minPatients: patientsField,
    maxPatients: patientsField,
    format: z.enum(ROBOT_TYPE_FORMATS, requiredEnum),
    mode: z.enum(ROBOT_TYPE_MODES, requiredEnum),
    status: z.enum(ROBOT_TYPE_STATUSES, requiredEnum),
  })
  .superRefine((data, ctx) => {
    if (data.maxPatients < data.minPatients) {
      ctx.addIssue({
        code: 'custom',
        path: ['maxPatients'],
        message: 'robotTypes:validation.maxLowerThanMin',
      })
    }
  })

export type RobotType = z.infer<typeof RobotTypeSchema>
export type SaveRobotType = z.infer<typeof SaveRobotTypeSchema>
export type RobotTypeStatus = RobotType['status']
